export enum AdminInviteType {
  GameAdminInvite = 1,
  CausableInvite = 2,
  CharityAdminInvite = 3,
  CrossGameInvite = 4
}
